var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#000",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M14.618 23.24H6.24a2.608 2.608 0 01-2.605-2.478L2.84 4.837h15.179l-.796 15.925a2.609 2.609 0 01-2.605 2.478zM1 4.837h18.859"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M12.09 1H8.768a2.607 2.607 0 00-2.607 2.608v1.23h8.538v-1.23A2.61 2.61 0 0012.09 1zm-1.661 6.598V20.48M6.611 7.598l.46 12.882m7.177-12.882l-.46 12.882"
  }))));
}
export default SvgIconTrash;